import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface MobileNavProps {
  userRole?: 'user' | 'admin';
}

const navItems = [
  { path: '/', icon: '🏠', label: 'Главная', color: '#3b82f6' },
  { path: '/finances', icon: '💰', label: 'Финансы', color: '#16a34a' },
  { path: '/goals', icon: '🎯', label: 'Цели', color: '#f59e0b' },
  { path: '/health', icon: '🏥', label: 'Здоровье', color: '#3b82f6' },
  { path: '/family', icon: '👨‍👩‍👧‍👦', label: 'Семья', color: '#8b5cf6' },
];

export const MobileBottomNav: React.FC<MobileNavProps> = ({ userRole }) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'white',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '8px 0',
        paddingBottom: 'max(8px, env(safe-area-inset-bottom))',
        zIndex: 1000,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      }}
    >
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textDecoration: 'none',
            color: isActive(item.path) ? item.color : '#9ca3af',
            fontSize: '10px',
            fontWeight: isActive(item.path) ? '600' : '400',
            padding: '4px 12px',
            borderRadius: '8px',
            background: isActive(item.path) ? `${item.color}15` : 'transparent',
            transition: 'all 0.2s',
            minWidth: '60px',
          }}
        >
          <span style={{ fontSize: '22px', marginBottom: '2px' }}>{item.icon}</span>
          <span>{item.label}</span>
        </Link>
      ))}
    </nav>
  );
};

interface MobileHeaderProps {
  userName?: string;
  onLogout: () => void;
  onAIClick?: () => void;
  userRole?: 'user' | 'admin';
  onAdminClick?: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  userName,
  onLogout,
  onAIClick,
  userRole,
  onAdminClick,
}) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  return (
    <>
      <header
        style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
          color: 'white',
          padding: '12px 16px',
          paddingTop: 'max(12px, env(safe-area-inset-top))',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: '20px' }}>🚀 Avatar</h1>
          <p style={{ margin: 0, fontSize: '12px', opacity: 0.9 }}>
            {userName || 'Пользователь'}
          </p>
        </div>

        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {/* AI Button */}
          <button
            id="ai-assistant-header-button"
            onClick={onAIClick}
            style={{
              padding: '8px 12px',
              background: 'rgba(255,255,255,0.25)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '18px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            🤖
          </button>

          {/* Menu Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              padding: '8px 12px',
              background: 'rgba(255,255,255,0.25)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '18px',
            }}
          >
            ☰
          </button>
        </div>
      </header>

      {/* Dropdown Menu */}
      {menuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1001,
          }}
          onClick={() => setMenuOpen(false)}
        >
          <div
            style={{
              position: 'absolute',
              top: '60px',
              right: '16px',
              background: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
              minWidth: '200px',
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Link
              to="/faq"
              onClick={() => setMenuOpen(false)}
              style={{
                display: 'block',
                padding: '14px 16px',
                textDecoration: 'none',
                color: '#333',
                borderBottom: '1px solid #eee',
              }}
            >
              ❓ FAQ
            </Link>
            <Link
              to="/news"
              onClick={() => setMenuOpen(false)}
              style={{
                display: 'block',
                padding: '14px 16px',
                textDecoration: 'none',
                color: '#333',
                borderBottom: '1px solid #eee',
              }}
            >
              📰 Новости
            </Link>
            {userRole === 'admin' && (
              <button
                onClick={() => {
                  setMenuOpen(false);
                  onAdminClick?.();
                }}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '14px 16px',
                  textAlign: 'left',
                  background: 'none',
                  border: 'none',
                  borderBottom: '1px solid #eee',
                  color: '#dc2626',
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
              >
                👑 Админка
              </button>
            )}
            <button
              onClick={() => {
                setMenuOpen(false);
                onLogout();
              }}
              style={{
                display: 'block',
                width: '100%',
                padding: '14px 16px',
                textAlign: 'left',
                background: 'none',
                border: 'none',
                color: '#ef4444',
                cursor: 'pointer',
                fontSize: '16px',
              }}
            >
              🚪 Выйти
            </button>
          </div>
        </div>
      )}
    </>
  );
};
